import { NgModule } from '@angular/core';
import { IonicModule } from 'ionic-angular';
import { PostPopoverComponent } from './post-popover/post-popover';
import { PostAttachmentComponent } from './post-attachment/post-attachment';
import { DemoAvatarComponent } from './demo-avatar/demo-avatar';
import { LunchrouletteComponent } from './lunchroulette/lunchroulette';
import { MobileHeaderComponent } from './mobile-header/mobile-header';
import {TranslateModule} from "@ngx-translate/core";
import { CustomButtonComponent } from './utils/custom-button/custom-button';
import { CustomInputComponent } from './utils/custom-input/custom-input';
import { ModalHeaderComponent } from './modal-header/modal-header';
import { CustomRadioComponent } from './utils/custom-radio/custom-radio';

@NgModule({
	declarations: [PostPopoverComponent,
    PostAttachmentComponent,
    DemoAvatarComponent,
    LunchrouletteComponent,
    MobileHeaderComponent,
    CustomButtonComponent,
    CustomInputComponent,
    ModalHeaderComponent,
    CustomRadioComponent,
  ],
  imports: [IonicModule, TranslateModule],
	entryComponents: [
		PostPopoverComponent,
		PostAttachmentComponent,
		DemoAvatarComponent
	],
	exports: [PostPopoverComponent,
    PostAttachmentComponent,
    DemoAvatarComponent,
    LunchrouletteComponent,
    MobileHeaderComponent,
    CustomButtonComponent,
    CustomInputComponent,
    ModalHeaderComponent,
    CustomRadioComponent,
    ]
})
export class ComponentsModule {}



// WEBPACK FOOTER //
// ./src/components/components.module.ts